import {createSlice} from '@reduxjs/toolkit';

// Placeholder imports for your new project images. 
// Update the paths and filenames when you have the actual assets.
import marketDataImg from '../images/MarketData.jpg'
import fpgaAudioImg from '../images/FPGAAudio.jpg'
import logicAnalyzerImg from '../images/LogicAnalyzer.png'
import roboticArmImg from '../images/RoboticArm.jpg'

export const projectsSlice = createSlice({
    name: 'Projects',
    initialState: {
        projects: [
            {
                id: "proj1",
                image: marketDataImg,
                name: "FPGA Market Data Processing Platform",
                description: "Architected a low latency High-Frequency Trading platform on an AMD Artix-7 FPGA, utilizing GTP transceivers for high-speed fiber optic market data ingestion. Designed custom RTL data paths in Verilog to parse data and make algorithmic trade execution decisions through a Gigabit Ethernet (GbE) interface. Integrated a DDR3 RAM memory controller via AXI interconnects to manage order book states, optimizing the architecture for deterministic, nanosecond-scale execution latencies.",
                shortDesc: "Low latency High-Frequency Trading platform on an AMD Artix-7 FPGA.",
                gitLink: "", 
                technologies: (
                    <ul>
                        <li>Verilog</li>
                        <li>AMD Artix-7</li>
                        <li>GTP Transceivers</li>
                        <li>Gigabit Ethernet (GbE)</li>
                        <li>DDR3 RAM</li>
                        <li>AMBA AXI</li>
                    </ul>
                )
            },
            {
                id: "proj2",
                image: fpgaAudioImg,
                name: "FPGA Audio Processing & Streaming",
                description: "Engineered a real-time audio processing application on an AMD Zynq-7000 FPGA, developing custom Verilog hardware blocks to apply digital audio effects. Programmed the application control software in C on the ARM Cortex-A9 processing system to orchestrate the hardware accelerators and interface with the audio codec via I2S, I2C, and AXI interconnects.",
                shortDesc: "Real-time audio processing application on an AMD Zynq-7000 FPGA.",
                gitLink: "", 
                technologies: (
                    <ul>
                        <li>Verilog</li>
                        <li>C Programming</li>
                        <li>AMD Zynq-7000</li>
                        <li>ARM Cortex-A9</li>
                        <li>AXI Interconnects</li>
                        <li>I2S & I2C Protocols</li>
                        <li>Ethernet</li>
                    </ul>
                )
            },
            {
                id: "proj3",
                image: logicAnalyzerImg,
                name: "High-Speed Logic Analyzer",
                description: "Engineered an ARM Cortex-M4 (STM32) based logic analyzer capable of a continuous 22.5 Mbps digital sampling rate, utilizing an external USB High-speed PHY over a length-matched ULPI interface. Implemented the open-source Sump protocol over a custom USB CDC stack to enable real-time waveform visualization and debugging in PulseView.",
                shortDesc: "STM32-based logic analyzer with a continuous 22.5 Mbps digital sampling rate.",
                gitLink: "", 
                technologies: (
                    <ul>
                        <li>C Programming</li>
                        <li>STM32 (ARM Cortex-M4)</li>
                        <li>USB High-Speed PHY</li>
                        <li>ULPI Interface</li>
                        <li>USB CDC Stack</li>
                        <li>Sump Protocol</li>
                    </ul>
                )
            },
            {
                id: "proj4",
                image: roboticArmImg,
                name: "Robotic Arm Controller",
                description: "Designed a custom 6DoF teleoperation controller in Altium Designer, leveraging the ESP32 platform to transmit low-latency dual-axis joystick telemetry data over Wi-Fi. Engineered a custom PCBA integrating a step-down buck converter for transient power regulation and a high-precision IMU interfaced via I2C for continuous motion tracking.",
                shortDesc: "Custom 6DoF teleoperation controller PCBA designed in Altium.",
                gitLink: "", 
                technologies: (
                    <ul>
                        <li>Altium Designer</li>
                        <li>LTSPICE</li>
                        <li>ESP-IDF (ESP32)</li>
                        <li>Wi-Fi Telemetry</li>
                        <li>I2C Protocol</li>
                        <li>Power Regulation (Buck Converter)</li>
                    </ul>
                )
            }
        ],
        books:[
            {
                id: "b1",
                title: "The Sociopath Next Door",
                description: "Who is the devil you know? Is it your lying, cheating ex-husband? Your sadistic high school gym teacher? Your boss who loves to humiliate people in meetings?",
                image: "https://m.media-amazon.com/images/I/81NZEWfNz5L.jpg",
                Author: "Martha Stout"
            },{
                id: "b2",
                title: "Mastery",
                description: "Mastery is the fifth book by the American author Robert Greene. The book examines the lives of historical figures such as Charles Darwin and Henry Ford, as well as the lives of contemporary leaders such as Paul Graham and Freddie Roach, and examines what led to their success.",
                image: "https://m.media-amazon.com/images/I/71LRdEUOmNL.jpg",
                Author: "Robert Greene"
            },{
                id: "b3",
                title: "Batman: The Killing Joke",
                description: "Batman: The Killing Joke is a 1988 DC Comics one-shot graphic novel featuring the characters Batman and the Joker written by Alan Moore and illustrated by Brian Bolland",
                image: "https://m.media-amazon.com/images/I/A1O+qcrE5YL.jpg",
                Author: "Alan Moore"
            },{
                id: "b4",
                title: "Shoe Dog",
                description: "Shoe Dog is a memoir by Nike co-founder Phil Knight. The memoir chronicles the history of Nike from its founding as Blue Ribbon Sports and its early challenges to its evolution into one of the world's most recognized and profitable companies. It also highlights certain parts of Phil Knight's life.",
                image: "https://m.media-amazon.com/images/I/71m3HEJJl5L.jpg",
                Author: "Phil Knight"
            },{
                id: "b5",
                title: "V for Vendetta",
                description: "A powerful story about loss of freedom and individuality, V FOR VENDETTA takes place in a totalitarian England following a devastating war that changed the face of the planet.",
                image: "https://m.media-amazon.com/images/I/71f7i5dHDSL.jpg",
                Author: "Alan Moore"
            },{
                id: "b6",
                title: "Everything Is F*cked",
                description: "We live in an interesting time. Materially, everything is the best it’s ever been—we are freer, healthier and wealthier than any people in human history. ",
                image: "https://m.media-amazon.com/images/I/719ThX10pEL.jpg",
                Author: "Mark Manson"
            },{
                id: "b7",
                title: "The Five People You Meet in Heaven",
                description: "The Five People You Meet In Heaven is a 2003 novel by Mitch Albom. It follows the life and death of a ride mechanic named Eddie who is killed in an amusement park accident and sent to heaven, where he encounters five people who had a significant impact on him while he was alive.",
                image: "https://m.media-amazon.com/images/I/41YThsfdegL.jpg",
                Author: "Mitch Albom"
            },{
                id: "b8",
                title: "I Was Never Here",
                description: "An ex-spy lifts the lid on life in the secret serviceA Globe and Mail and Toronto Star bestseller!Andrew Kirsch didn’t grow up watching spy movies, or dreaming about being a real-life James Bond. He was hardly aware that Canada even had its own intelligence service—let alone knew what its officers did.",
                image: "https://m.media-amazon.com/images/I/81CPrcNZRpL.jpg",
                Author: "Andrew Kirsch"
            }
        ]
    },
    reducers: {

    }
});